import { useState, useEffect } from "react";
import restApiHost from ".";
import MainPage from "./pages/MainPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NewsPage from "./components/NewsPage";
import ProfilePage from "./pages/ProfilePage";
import UserImagesPage from "./pages/UserImagesPage";
import { useSearchParams } from 'react-router-dom';


function App() {
  const [activeCategory, setActiveCategory] = useState('Казино');
  const [activeSubcategory, setActiveSubcategory] = useState('Казино');
  const [isLoading, setIsLoading] = useState(false);
  const [activeCommunitySubcategory, setActiveCommunitySubcategory] = useState('Новости')
  const [isSupportSectionOpen, setSupportSectionOpen] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userImage, setUserImage] = useState(null);
  const [userName, setUserName] = useState(null);
  const [isPopupShowing, setPopupShowing] = useState(false);


  useEffect(() => {

    const getPhoneNumberFromParams = () => {
      setPhoneNumber(searchParams.get('phone') || null);
    }

    async function fetchUserInfo() {
      const response = await fetch(restApiHost + '/api/get-user/', {
        method: 'POST', // Указываем метод POST
        headers: {
          'Content-Type': 'application/json' // Указываем тип контента как JSON
        },
        body: JSON.stringify({phone_number: phoneNumber}) // Передаем тело запроса с ключом request_url
      })
      const data = await response.json();
      setUserId(data.id);
      setUserImage(data.image);
      setUserName(data.name)
    }

    if (!phoneNumber) {
      getPhoneNumberFromParams()
    }

    if (phoneNumber && !userId && !userName){
      fetchUserInfo();
    }

  }, [phoneNumber, searchParams, userId, userImage, userName])

  const [games, setGames] = useState(null);
  const [casino, setCasino] = useState(null);
  const [bettings, setBetting] = useState(null);
  const [countryName, setCountryName] = useState('russia');   
  const [news, setNews] = useState([]);                                                                                

  useEffect(()  => {
    
    async function fetchCountryName() {
      const response = await fetch('https://utgeoip.site/geo/get_country_name/');
      const data = await response.json();
      const country = data.country_name.toLowerCase();
      if (country !== 'russia') {
        setPopupShowing(true);
      }
      setCountryName(country);
    }

    async function fetchNews() {
      const response = await fetch(restApiHost + '/api/get-news/');
      const data = await response.json();
      const news = data.news;
      setNews(news);
    }
  
    async function fetchData () {
      const response = await fetch(restApiHost + '/api/get-main-page-data/' + countryName + '/');
      const data = await response.json();
      const games = data.games.map(item => ({ 
        ...item, 
        isClicked: false 
      }));
      setGames(games);
      const casino = data.casino.map(item => ({ 
        ...item, 
        isClicked: false 
      }));
      setCasino(casino);
      const betting = data.betting.map(item => ({ 
        ...item, 
        isClicked: false 
      }));
      setBetting(betting);
    };

    

    if (countryName === null) {
      fetchCountryName();
    }
    // if (news.length === 0){
    //   fetchNews();
    // }
    if (countryName !== null && games === null) {
      fetchData()
    }
    setIsLoading(false);

  }, [countryName, games, news]);


  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (event) => {
      setInputValue(event.target.value);
  };

  const ClearInput = () => {
      setInputValue('')
  }
  
  const filteredOfers = (games || []).filter(offer => {
      return [offer.title, ...offer.title_for_look].some(item =>
          item.toLowerCase().includes(inputValue.toLowerCase())
      );})

  const handleLoaderClick = () => {
    setIsLoading(false); // Скрываем лоадер при клике на него
  };

  

  return (
    <BrowserRouter>
      <Routes>
         <Route path='/' element={<MainPage 
            isLoading={isLoading} handleLoaderClick={handleLoaderClick} activeSubcategory={activeSubcategory} activeCategory={activeCategory}
            setActiveCategory={setActiveCategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName}
            games={games} inputValue={inputValue} filteredOfers={filteredOfers} setInputValue={setInputValue} handleInputChange={handleInputChange}
            ClearInput={ClearInput} casino={casino} bettings={bettings} setCasino={setCasino} setBetting={setBetting} setIsLoading={setIsLoading} activeCommunitySubcategory={activeCommunitySubcategory}
            isSupportSectionOpen={isSupportSectionOpen} setActiveCommunitySubcategory={setActiveCommunitySubcategory} setSupportSectionOpen={setSupportSectionOpen}
            news={news} phoneNumber={phoneNumber} userId={userId} userName={userName} userImage={userImage} setPopupShowing={setPopupShowing} isPopupShowing={isPopupShowing}
          />}/>
          <Route path='/news' element={<NewsPage news={news} activeCategory={activeCategory} setActiveCategory={setActiveCategory} activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName} phoneNumber={phoneNumber} setActiveCommunitySubcategory={setActiveCommunitySubcategory}/>}/>
          <Route path='/profile' element={<ProfilePage activeCategory={activeCategory} activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName} activeCommunitySubcategory={activeCommunitySubcategory} setActiveCommunitySubcategory={setActiveCommunitySubcategory} phoneNumber={phoneNumber} userImage={userImage} userName={userName} userId={userId} setUserName={setUserName}/>}/>
          <Route path='/user-images' element={<UserImagesPage activeCategory={activeCategory} activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName} activeCommunitySubcategory={activeCommunitySubcategory} setActiveCommunitySubcategory={setActiveCommunitySubcategory} phoneNumber={phoneNumber} userImage={userImage} userId={userId} setUserImage={setUserImage}/>}/>
      </Routes>
    </BrowserRouter>
    
  );
}

export default App;
